import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[filedrop]',
    standalone: false
})
export class FileDropDirective {

  @Input('fileType') fileType?: string = '';

  @Output() filesDropped = new EventEmitter<FileList>();
  @Output() filesHovered =  new EventEmitter<boolean>();
  @HostBinding("style.background") protected background = "white";

  constructor() { }

  private isFileAccepted(file: File, fileType?: string): boolean {
    if (!file) {
      return false;
    }

    if (!fileType || fileType.trim().length === 0) {
      return true;
    }

    const fileMimeType = (file.type || '').toLowerCase();
    const [mimeMajor, mimeMinor] = fileMimeType.split('/');
    const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
    const fileExtensionWithDot = fileExtension ? `.${fileExtension}` : '';

    return fileType.split(',').some((rawType) => {
      const type = rawType.trim().toLowerCase();

      if (!type) {
        return false;
      }

      if (type === '*' || type === '*/*') {
        return true;
      }

      if (type.endsWith('/*')) {
        const major = type.slice(0, -2);
        return major === mimeMajor;
      }

      if (type.startsWith('.')) {
        return type === fileExtensionWithDot;
      }

      if (type.includes('/')) {
        return type === fileMimeType;
      }

      return type === mimeMajor || type === mimeMinor || type === fileExtension || type === fileExtensionWithDot;
    });
  }

  @HostListener('drop', ['$event'])
  onDrop($event) {
    $event.preventDefault();

    const files = $event.dataTransfer?.files;
    const firstFile = files?.[0];

    if (files && this.isFileAccepted(firstFile, this.fileType)) {
      this.filesDropped.emit(files);
      this.filesHovered.emit(false);
    } else if (firstFile) {
      window.alert('Wrong type');
    }
    
    this.background = "white";
  }

  @HostListener('dragover', ['$event'])
  onDragOver($event) {
    $event.preventDefault();
    this.background = "#eee";
    this.filesHovered.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave($event) {
    this.background = "white";
    this.filesHovered.emit(false);
  }
}
